import { IntlShape } from 'react-intl';

import { DOCUMENT_TYPE_MESSAGE_IDS } from '../config/constants';
import { DocumentType } from '../config/types';

import { parseDocumentType } from './normalizeDocumentType';

const fallbackHumanize = (value: string): string =>
  value
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getDocumentTypeLabel = (
  formatMessage: IntlShape['formatMessage'],
  type?: DocumentType | string | null,
): string => {
  if (!type) {
    return '—';
  }

  const normalizedType = parseDocumentType(type);

  if (!normalizedType) {
    return fallbackHumanize(String(type));
  }

  return formatMessage({ id: DOCUMENT_TYPE_MESSAGE_IDS[normalizedType] });
};
